import { Component } from '@angular/core';
import { MatButton, MatIconButton } from '@angular/material/button';
import { MatDialogActions, MatDialogClose, MatDialogTitle } from '@angular/material/dialog';
import { MatIcon } from '@angular/material/icon';

@Component({
  selector: 'eca-confirm-clear-alerts',
  templateUrl: './confirm-clear-alerts-dialog.component.html',
  styleUrls: ['./confirm-clear-alerts-dialog.component.scss'],
  imports: [MatIconButton, MatDialogClose, MatIcon, MatDialogTitle, MatDialogActions, MatButton]
})
export class ConfirmClearAlertsDialogComponent {

  constructor() { }

}
